import { get } from 'lodash';

// Server states that mean a close is in flight (requested/approved/archiving).
// Shared by the list page (status column) and the detail page (close-flow gating).
export const IN_PROGRESS_STATES = ['CLOSE_REQUESTED', 'CLOSE_APPROVED', 'ARCHIVING'];

/** True if the season row is CLOSED (real state from ListComplianceSeasons). */
export const isSeasonClosedFor = (seasons, studyPeriod) => {
  const season = (seasons || []).find(s => String(get(s, 'studyPeriod')) === String(studyPeriod));
  return typeof get(season, 'state') === 'string' && season.state.toLowerCase() === 'closed';
};

/**
 * Derive the close-flow state for a season from its (getStudySummary SEASON)
 * summary, the ListComplianceSeasons rows, and any in-flight close result.
 *
 * `stateConfirmed` is true only when the SEASON summary loaded — callers must
 * gate the irreversible Close/Retry affordance on it, so a season whose state
 * couldn't be confirmed (fetch failed / not yet loaded) never shows Close.
 *
 * @returns {{ serverState, closed, closePending, closeFailed, stateConfirmed }}
 */
export const deriveCloseState = ({ seasonSummary, seasons, studyPeriod, closeResult } = {}) => {
  const serverState = String(get(seasonSummary, 'state', '')).toUpperCase();

  const realClosed = seasonSummary
    ? seasonSummary.writeBlocked === true ||
      seasonSummary.reviewFeaturesEnabled === true ||
      serverState === 'CLOSED'
    : false;
  const closed = realClosed || isSeasonClosedFor(seasons, studyPeriod);

  const serverClosePending = IN_PROGRESS_STATES.includes(serverState);
  const closeFailed = !closed && serverState === 'CLOSE_FAILED';
  const closePending =
    !closed &&
    !closeFailed &&
    (serverClosePending || get(closeResult, 'status', '') === 'PENDING_APPROVAL');

  return {
    serverState,
    closed,
    closePending,
    closeFailed,
    // The SEASON summary loaded, so we have a confirmed OPEN/CLOSED/CLOSE_FAILED/...
    // state to act on. Null summary => unknown state => don't offer Close.
    stateConfirmed: seasonSummary != null,
  };
};
